export default "__VITE_ASSET__0536135f__"